import React, { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import { CommentButtonAction } from '@components/Feed/Post/ActionButtons';
import { FeedPlaylistPost } from '@components/Feed/Post/PostTypes/FeedPlaylistPost';
import { FeedReleasePost } from '@components/Feed/Post/PostTypes/FeedReleasePost';
import type { ActionButtonsRepostSourceFragmentDoc } from '@graphql/reactQuery';
import { type FragmentType, getFragment, PostGroupItemFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment PostGroupItem on Post {
    id
    __typename
    ... on ReleasePost {
      ...FeedReleasePost
    }

    ... on PlaylistPost {
      ...FeedPlaylistPost
    }
  }
`);

export const PostGroupItem = ({
  postFrag,
  repostSource,
}: {
  postFrag: FragmentType<PostGroupItemFragmentDoc>;
  repostSource: FragmentType<ActionButtonsRepostSourceFragmentDoc> | null;
}) => {
  const post = getFragment(PostGroupItemFragmentDoc, postFrag);

  const content = useMemo(() => {
    switch (post.__typename) {
      case 'ReleasePost':
        return (
          <FeedReleasePost
            releasePostFrag={post}
            commentButtonAction={CommentButtonAction.FocusInput}
            collectButtonSource="Feed Post Sound Bar"
            shareButtonSource="Post Feed Card"
            source="Post Feed Card"
            repostSource={repostSource}
          />
        );
      case 'PlaylistPost':
        return (
          <FeedPlaylistPost
            playlistPostFrag={post}
            commentButtonAction={CommentButtonAction.FocusInput}
            shareButtonSource="Post Feed Card"
            source="Post Feed Card"
            repostSource={repostSource}
          />
        );

      default:
        return (
          <div className="text-base-s text-neutral400">There was an error loading this post</div>
        );
    }
  }, [post, repostSource]);

  return content;
};
